import React, { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputFields from "../../utils/UserInput";
import { message, Modal } from "antd";
import ImageUpload from "./UploadImage";
import { useSelector } from "react-redux";
import { SelectEmployee } from "../SelectInput";
import { getRequest, MultiPostRequest } from "../../utils/APICall";
import moment from "moment";
import UserImg from '../../assets/user.png';
import { XMarkIcon } from "@heroicons/react/16/solid";

const UserForm = ({ visible, onClose }) => {
  const [employeeId, setEmployeeId] = useState(null);
  const { users } = useSelector((state) => state.user || {})

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    userName: Yup.string().required("Username is required"),
    password: Yup.string().min(3, "Password must be at least 3 characters").required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password")], "Passwords must match")
      .required("Confirm password is required"),
    phone: Yup.string().required("Phone is required"),
    role: Yup.string().required("Role is required"),
    userType: Yup.string().required("User Type  is required"),
  });

  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    userName: "",
    password: "",
    phone: "",
    role: "",
    userType: "",
    webAccess: "",
    imageId: "",
    userImg: UserImg,
  };

  const userTypes = [
    { label: "Admin", value: 1 },
    { label: "Employee", value: 2 },
    { label: "Client", value: 3 },
  ];
  const userRoles = [
    { label: "Admin", value: 1 },
    { label: "HR", value: 4 },
    { label: "Accountant", value: 5 },
    { label: "Employee", value: 2 },
    { label: "Client", value: 3 },
  ];
  const { allEmployee } = useSelector((state) => state.employees);
  function removeDuplicatesByID(array) {
    const seen = new Set();
    return array.filter((item) => {
      if (seen.has(item.ID)) {
        return false;
      }
      seen.add(item.ID);
      return true;
    });
  }
  const filterData = removeDuplicatesByID(allEmployee)
  const handleSubmit = async (values, { resetForm }) => {
    // console.log("Values--->>>>", values);
    const formData = new FormData();
    for (const key in values) {
      formData.append(key, values[key]);
    }
    formData.append("employeeId", String(employeeId));
    formData.append("createdby", `${users?.FIRSTNAME} ${users?.LASTNAME} | ${moment(Date.now()).format("DD-MM-YYYY HH:mm")}`);

    // console.log("Submitting employee data:", Object.fromEntries(formData));
    try {
      const res = await MultiPostRequest("addUser", formData)
      //console.log("response-->>>>>>", res)
      if (res?.success) {
        message.success("User Created Successfully")
        onClose()
        resetForm()
        window.location.reload()

      }
    } catch (error) {
      console.log("API error", error)
    }

  };
  return (
    <Modal
      title={
        <div className="text-xl font-bold  text-center pb-3 dark:bg-gray-900 dark:text-gray-100">
          Add User
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
       closeIcon={
        <XMarkIcon
          className={"h-5 w-5  dark:text-white text-black"}
        />
      }
      className="dark:[&_.ant-modal-content]:bg-gray-900"
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue, values,resetForm }) => {

          const getEmpById = async () => {
            if (!employeeId) return ;

            const res = await getRequest(`getEmpById?id=${employeeId}`);
            // console.log("response", res);

            if (res?.success && res?.data?.length > 0) {
              const emp = res.data[0];
              // Now set values into form fields
              setFieldValue("firstName", emp.FIRSTNAME || "");
              setFieldValue("lastName", emp.LASTNAME || "");
              setFieldValue("email", emp.EMAIL || "");
              setFieldValue("phone", emp.PHONE || "");
              setFieldValue("userImg", emp.IMAGEURL || "");
              setFieldValue("imageId", emp.FKIMAGEID || "");
              // Add more mappings as needed
            } else{
              resetForm()
            }
          };
          return (
            <Form className="dark:bg-gray-900 ">
              <span className="flex justify-center items-center py-4  ">
                <div
                  className="relative w-32 h-32 rounded-full overflow-hidden shadow-lg border border-gray-200"
                >
                  <img
                    src={values.userImg || UserImg} 
                    alt={`Uploaded `}
                    name="userImg"
                    className="w-full h-full object-contain"
                  />
                </div>
                {/* <ImageUpload setData={setDataFiles} images={images} setImages={setImages} /> */}

              </span>
              <span className="grid  grid-cols-1 gap-2 md:grid-cols-2 ">
                <InputFields
                  label="First Name"
                  type="text"
                  placeholder="Enter your firstName"
                  name="firstName"
                />
                <InputFields
                  label="Last Name"
                  type="text"
                  placeholder="Enter lastName"
                  name="lastName"
                />

                <InputFields
                  label="Email"
                  type="email"
                  name="email"
                  placeholder="Enter Email"
                />
                <InputFields
                  label="User Name"
                  type="text"
                  placeholder="Enter userName"
                  name="userName"
                />
                <InputFields
                  label="Password"
                  type="password"
                  name="password"
                  placeholder="Enter Password"
                />
                <InputFields
                  label="Confirm Password"
                  type="password"
                  placeholder="Enter confirmPassword"
                  name="confirmPassword"
                />
                <InputFields
                  label="Phone"
                  type="number"
                  name="phone"
                  placeholder="Enter Phone"
                />
                <span>

                  <label className='block font-semibold '>
                    Employee Name
                    {/* <span className="text-red-500">*</span> */}
                  </label>
                  <SelectEmployee
                    employeeList={filterData}
                    onChange={(value) => {
                      // console.log("👤 Selected Employee ID:", value);
                      setEmployeeId(value);
                      // setFieldValue("empName", value);
                    }}
                    selectedEmployee={employeeId}
                    customStyle="w-full h-full"
                    allLabel={{}}
                  />
                </span>
                <InputFields
                  label="User Role"
                  type="select"
                  placeholder="Enter Role"
                  name="role"
                  options={userRoles}
                />
                <InputFields
                  label="User Type"
                  type="select"
                  placeholder="Enter Type"
                  name="userType"
                  options={userTypes}
                />
                <InputFields
                  label="Web Access"
                  type="checkbox"
                  name="webAccess"
                />
              </span>

              <span className="flex gap-4">
                <button
                  onClick={getEmpById}
                  type="button"
                  className="mt-6 relative ml-auto w-40 max-h-10 bg-blue-500 text-white px-4 py-2 rounded"
                >
                  Search
                </button>
                <button
                  type="submit"
                  className="mt-6 relative ml-auto w-40 max-h-10 bg-blue-500 text-white px-4 py-2 rounded"
                >
                  Submit
                </button>
              </span>
            </Form>
          )
        }}
      </Formik>
    </Modal>
  )
}

export default UserForm